<template>
  <b-modal
    v-model="isModalOpen"
    :title="t('container.sendRequestModal.title')"
    @ok="sendMergeRequest"
    :ok-title="t('container.sendRequestModal.send')"
    :ok-disabled="selectedEmails.length === 0 || sendLoading"
  >
    <span>{{ t('container.sendRequestModal.description') }}</span>
    <b-form-group :label="t('common.recipients')">
      <tc-multiselect
        v-model="selectedEmails"
        :options="emails"
        :dynamic-props="{
          label: 'value',
          trackBy: 'value',
          multiple: true,
          disabled: loading,
          loading: loading,
          max: 10,
        }"
      />
    </b-form-group>
  </b-modal>
</template>
<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import TcMultiselect from '@components/forms/tc-multiselect.vue';
import { axiosApi } from '@models/axios';
import { jsonApi } from '@models/jsonApi';

const { t } = useI18n({ useScope: 'global' });
const isModalOpen = ref(false);
const selectedEmails = ref([]);
const emails = ref([]);
const store = useStore();
const loading = ref(false);
const sendLoading = ref(false);

const openModal = async () => {
  isModalOpen.value = true;
  selectedEmails.value = [];
  loading.value = true;
  //avoid fetching emails if they are already set
  try {
    if (emails.value.length === 0) {
      const users = await jsonApi.request(`/users/emails-merge-request`, 'GET');
      emails.value = users.data?.map(user => ({
        value: user.email,
        label: user.email,
      }));
    }
  } catch (error) {
    console.error(error);
    store.commit('notifications/pushDanger', error?.message);
    isModalOpen.value = false;
  }
  loading.value = false;
};

const sendMergeRequest = async () => {
  sendLoading.value = true;
  try {
    await axiosApi.post(`/tms/web-containers/${store.state.tms.webContainer.entity.id}/send-merge-request`, {
      data: {
        attributes: {
          emails: selectedEmails.value.map(email => email.value),
        },
      },
    });
  } catch (error) {
    store.commit('notifications/pushDanger', error?.message);
  }
  sendLoading.value = false;
  isModalOpen.value = false;
  store.commit('notifications/pushSuccess', t('container.sendRequestModal.success'));
};

defineExpose({
  openModal,
});
</script>
